// The hero screenshot set lives in public/hero under versioned names (bump the
// v-number when the screenshot changes). Shared by the Hero component and the
// build-time prerender, which preloads the same candidate list from <head>.
export const HERO_WIDTHS = [640, 960, 1280, 1920] as const;

export const HERO_WEBP_SRCSET = HERO_WIDTHS.map((w) => `/hero/hero-dashboard-v2-${w}.webp ${w}w`).join(", ");

// The image sits in a max-w-6xl (72rem) container with 2rem side padding.
export const HERO_SIZES = "(min-width: 1216px) 1152px, calc(100vw - 4rem)";

/** Fallback candidate for browsers that ignore imagesrcset on a preload. */
export const HERO_PRELOAD_HREF = "/hero/hero-dashboard-v2-1280.webp";
